import { render, staticRenderFns } from "./TdcV3.vue?vue&type=template&id=31f1c50f&scoped=true&"
import script from "./TdcV3.vue?vue&type=script&lang=js&"
export * from "./TdcV3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f1c50f",
  null
  
)

export default component.exports